export default __webpack_public_path__ + "static/media/2014-JB.48432cd3.jpg";